import $ from 'jquery';

window.jQuery = $;
window.$ = $;

const showProjects = function (type) {
  $('.js-filter-projects-on-map').removeClass('selected');
  if (type === 'all') {
    $('.project_link').fadeIn('slow');
  } else {
    $('.project_link').fadeOut();
    $('.project_link').each(function () {
      if ($(this).data('status') === type) {
        $(this).fadeIn('slow');
      }
    });
  }
};

showProjects('all');
$('#all-the-projects-button').addClass('selected');

$('.js-filter-projects-on-map').click(function () {
  showProjects($(this).data('filter'));
  $(this).addClass('selected');
});
